import { useCities } from '~/store/cites/cities.store'

export default function useReviews() {
  const ctx = useNuxtApp()
  const cityStore = useCities()

  const currentCity = computed(() => cityStore.getCity)

  const client = ctx._apolloClients.default

  const fetchReviews = async (input?) => {
    try {
      const { data } = await client.query({
        query: gql`
          query getProvidersReviews(
            $input: ProviderReviewsInput!
          ) {
            reviews {
              providerReviews(input: $input) {
                page
                hasNext
                totalItems
                data {
                  authorName
                  areaRelative
                  commentsCount
                  created
                  currentUserReaction
                  dislikes
                  id
                  likes
                  locationDisplay
                  positive
                  provider {
                    id
                    logo
                    name
                    slug
                    logoT {
                      url(options: { width: 200, halign: "left" })
                      unoptimized
                    }
                  }
                  ratingConnection
                  ratingFinal
                  ratingService
                  ratingSpeed
                  ratingStability
                  text
                }
              }
            }
          }
        `,
        variables: {
          input: {
            fiasId: currentCity.value?.fias_id,
            ...input,
          },
        },
      })

      return data?.reviews?.providerReviews ?? []
    }
    catch (error) {
      console.error('Ошибка загрузки отзывов:', error)
      return []
    }
  }

  return {
    fetchReviews,
  }
}
